export const FB_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
export const FB_SDK_VERSION = 'v11.0';
export const DEFAULT_PERMISSIONS = [];
